import { z } from 'zod';

export const itemValidationTypeSchema = z.enum([ 'None','All','AllButOne','Categories','One','Manual' ]);

export const itemChildrenLayoutSchema = z.enum([ 'List', 'Grid', 'Hide', 'TwoLevels' ]);

export const itemEntryMinAdmittedMembersRatioSchema = z.enum([ 'All', 'Half', 'One', 'None' ]);

export const itemChildCategorySchema = z.enum([ 'Undefined', 'Discovery', 'Application', 'Validation', 'Challenge' ]);
export type ItemChildCategory = z.infer<typeof itemChildCategorySchema>;
